module.exports = __webpack_public_path__ + "img/produto-favorito-check.56d93124.svg";